import { cn } from "lib/utils";
import type { FC, ReactNode } from "react";

type DismissibleAlertProps = {
  children: ReactNode;
  variant?: "error" | "warning" | "info" | "success";
  onDismiss: () => void;
};

const variantClass: Record<string, string> = {
  error: "alert-error",
  warning: "alert-warning",
  info: "alert-info",
  success: "alert-success",
};

/**
 * バツボタン付き閉じられるアラート。
 * className は受け取らない。マージン等のレイアウトは親で吸収する。
 * @param {DismissibleAlertProps} props コンポーネントProps
 * @return {JSX.Element} DismissibleAlert
 */
export const DismissibleAlert: FC<DismissibleAlertProps> = ({
  children,
  variant = "error",
  onDismiss,
}) => {
  return (
    <div
      className={cn(
        "alert flex justify-between items-center",
        variantClass[variant],
      )}
    >
      <span>{children}</span>
      <button
        type="button"
        className="btn btn-ghost btn-xs ml-auto"
        onClick={onDismiss}
      >
        ✕
      </button>
    </div>
  );
};
